import { Component, OnInit } from '@angular/core';
import { UserStorageService } from 'src/app/services/storage/user-storage.service';
import { environment } from 'src/environments/environment';
import packageJson from '../../../../package.json';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.css'],
    standalone: false
})
export class HelpComponent implements OnInit {

  isDataLoaded: boolean = false;
  showMenu: boolean = false;
  appVersion: string = packageJson.version;
  tosPath: string = environment.resourcePath + 'ScheduleA_TermsConditions.pdf';

  ngOnInit(): void {
    const user = UserStorageService.currUser;
    this.showMenu = !!user?.userEmail?.trim();
    this.isDataLoaded = true;
  }

}
